import React, { useEffect, useState } from 'react'
import './bill-view.scss'
import { useNavigate, useParams } from 'react-router-dom'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { accountingAxios } from '../../config/axios'
import { FaDotCircle } from 'react-icons/fa'
import { formatStringDate, formatAmount } from '../../assets/javascript/formate-functions'
import PayAmount from '../../components/user/finance/PayAmount'
import Modal from '../../components/common/modal/Modal'



function PromiseView() {
    const { promise_uuid } = useParams()
    const [data, setData] = useState({})
    const navigate = useNavigate()
    const [loading, setLoading] = useState('fetch')
    const [modal, setModal] = useState({ status: false })


    const handlePay = () => {
        setModal({
            status: true,
            title: "Pay Now",
            content: <PayAmount bill_no={data?.bill_no} payable_amount={data?.promised_amount} setModal={setModal} />
        })
    }


    useEffect(() => {
        accountingAxios.get(`/v2/payment-promise/${promise_uuid}`).then((response) => {
            if (response.data) {
                setData(response.data)
                setLoading('')
            } else {
                navigate('/')
                setLoading('')
            }
        })

        // eslint-disable-next-line
    }, [])

    return (
        <div className='single-bill-view'>
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={[`Promise View / ${data?.party?.id ?? 'Loading...'}`]}>
                {loading === 'fetch'
                    ? <SpinWithMessage message={'Fetch data...'} />
                    :
                    <>
                        <div className="top-div" style={{ justifyContent: 'flex-end' }}>
                            <div className="buttons-div">
                                {data?.status === 'ACTIVE' &&
                                    <button style={{ backgroundColor: '#0066ff' }} onClick={handlePay}>Pay</button>}
                                {data?.receipt_no && <button onClick={() => navigate(`/receipts?receipt_no=${data?.receipt_no}`)}>Receipt</button>}
                                {data?.bill_no && <button onClick={() => navigate(`/bills?bill_no=${data?.bill_no}`)}>Bill</button>}
                            </div>
                        </div>
                        <div className="single-border" >
                            <div className="section-one" style={{ gridTemplateColumns: "1fr" }}>
                                {/* Service Details */}
                                <div className="card-div">
                                    <div className="head-div">
                                        <FaDotCircle />
                                        <h4>About Payment Promise</h4>
                                    </div>
                                    <div className="content-div">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>Party Type</td>
                                                    <td>: {data?.party?.type}</td>
                                                </tr>
                                                <tr>
                                                    <td>Party</td>
                                                    <td>: {data?.party?.id}, {data?.party?.name}</td>
                                                </tr>
                                                <tr>
                                                    <td>Created Date</td>
                                                    <td>: {data?.date ? formatStringDate(data?.date) : 'Nil'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Bill No</td>
                                                    <td>: {data?.bill_no || 'Nil'}</td>
                                                </tr>
                                                <tr style={{ fontWeight: "700" }}>
                                                    <td>Promise Amount</td>
                                                    <td>: ₹{formatAmount(data?.promised_amount || 0)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Promise Date</td>
                                                    <td>: {data?.promised_date ? formatStringDate(data?.promised_date) : 'Nil'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Comment / Reason</td>
                                                    <td>: {data?.comment ?? ''}</td>
                                                </tr>
                                                <tr>
                                                    <td>Under By</td>
                                                    <td>: {data?.collector_by ? data?.collector_by : 'SYSTEM'}</td>
                                                </tr>

                                                <tr style={{ fontWeight: "700" }}>
                                                    <td>Status</td>
                                                    <td>: {data?.status} </td>
                                                </tr>
                                                {data?.paid_amount ? <tr style={{ fontWeight: "700" }}>
                                                    <td>Paid Amount</td>
                                                    <td>: ₹{formatAmount(data?.paid_amount || 0)}</td>
                                                </tr> : ''}
                                                {data?.paid_date && <tr>
                                                    <td>Payment Date</td>
                                                    <td>: {data?.paid_date ? formatStringDate(data?.paid_date) : 'Nil'}</td>
                                                </tr>}
                                                {data?.receipt_no && <tr>
                                                    <td>Receipt No</td>
                                                    <td>: {data?.receipt_no ?? ''}</td>
                                                </tr>}
                                                {data?.remark && <tr>
                                                    <td>Remark</td>
                                                    <td>: {data?.remark ?? ''}</td>
                                                </tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>}
            </SinglePage>
        </div >
    )
}

export default PromiseView